module.exports = __webpack_public_path__ + "media/src/website/images/locations/tegernsee/tegernsee_01-43a57491a826290626c75c1e0c069d71.jpg";